import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as SearchSeriesActions from 'rebook/apps/search/actions/SearchSeriesActions';
import SeriesList from 'rebook/apps/catalog/components/SeriesList';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BackLink from 'rebook/apps/base/components/BackLink';
import ContentNotFound from 'rebook/apps/base/components/ContentNotFound';
import SpinnerLoader from 'rebook/apps/base/components/SpinnerLoader';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


class SearchSeriesView extends React.Component {
  componentDidMount() {
    this.props.SearchSeriesActions.fetchInitialData(this.props.location);
  }

  componentWillUnmount() {
    this.props.SearchSeriesActions.resetData();
  }

  changePage(newPageNumber) {
    this.props.SearchSeriesActions.fetchSeries(newPageNumber);
  }

  render() {
    const {
      seriesList, seriesCount, query, pageNumber, lastPageNumber, isLoading,
    } = this.props.searchSeries;

    if (isLoading) {
      return (
        <div className="backgroundContainer themeGrey">
          <div className="section">
            <SpinnerLoader />
          </div>
        </div>
      );
    }

    return seriesList
      ? (
        <div className="backgroundContainer themeGrey">
          <div className="section">
            <BackLink link={`/search/?q=${query}`} extraClassName={styles.breadCrumbs} isMargined>
              <span className="link">Все результаты</span>
            </BackLink>
            <div className="title-1">
              Все серии по запросу «{query}»
            </div>
            <small>
              {seriesCount} {pluralize(seriesCount, 'серия', 'серии', 'серий')}
            </small>
            <SeriesList series={seriesList} />
            <ContextPagination
              onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
              currentPage={pageNumber}
              lastPage={lastPageNumber} />
          </div>
        </div>
      )
      : (
        <ContentNotFound>
          <header>К сожалению, по вашему запросу <br />ничего не найдено.</header>
          <article>
            Скорее всего, у нас нет такой книги или автора. <br />
            Попробуйте поискать что-нибудь другое.
          </article>
        </ContentNotFound>
      );
  }
}

function mapStateToProps(state) {
  return {
    searchSeries: state.searchSeries,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    SearchSeriesActions: bindActionCreators(SearchSeriesActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchSeriesView);
